export default __webpack_public_path__ + "static/media/synapps-ascii-art.5239d270.txt";